import { render, staticRenderFns } from "./GlassType.vue?vue&type=template&id=873aeba4&scoped=true"
import script from "./GlassType.vue?vue&type=script&lang=ts"
export * from "./GlassType.vue?vue&type=script&lang=ts"
import style0 from "./GlassType.vue?vue&type=style&index=0&id=873aeba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873aeba4",
  null
  
)

export default component.exports